const LOGO = "https://xt30sf.b-cdn.net/media/b1c35ec0b8d96f3dde3fa.png";

const paymentLogos = [
  { src: "https://xt30sf.b-cdn.net/media/53b5d40061396a2f2173c.png", alt: "Visa", w: 72, h: 32 },
  { src: "https://xt30sf.b-cdn.net/media/45897b0061396a8921f26.png", alt: "Mastercard", w: 75, h: 34 },
  { src: "https://xt30sf.b-cdn.net/media/6c1f142061396b1b1d924.png", alt: "Google Pay", w: 75, h: 34 },
  { src: "https://xt30sf.b-cdn.net/media/8e7d5410613965b22e34a.png", alt: "Apple Pay", w: 64, h: 26 },
  { src: "https://xt30sf.b-cdn.net/media/66e97f20613969d994bb9.png", alt: "AmoPay", w: 75, h: 34 },
  { src: "https://xt30sf.b-cdn.net/media/656a0730613969324beeb.png", alt: "SpeedPay", w: 75, h: 34 },
  { src: "https://xt30sf.b-cdn.net/media/765dcdef5139686d734a5.png", alt: "OSKO", w: 75, h: 34 },
  { src: "https://xt30sf.b-cdn.net/media/08c834ef51396bb598c3a.png", alt: "PayID", w: 75, h: 34 },
];

const trustLogos = [
  { src: "https://xt30sf.b-cdn.net/media/5dad4f30613963c1d6f0e.png", alt: "PAGCOR", w: 80, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/1fbd0940613965ecea80d.png", alt: "BMM Testlabs", w: 80, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/fec6515061396fbd3c26b.png", alt: "ThreatMetrix", w: 70, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/fe74ac50613962679be2c.png", alt: "TST Verified", w: 60, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/25b6a86061396e4313830.png", alt: "SSL Secure", w: 60, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/51524680613964df823a2.png", alt: "ThreatMetrix 2", w: 70, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/5d645e8061396433b427b.png", alt: "TST Verified 2", w: 60, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/a5ba559061396903f1413.png", alt: "SSL Secure 2", w: 60, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/9129bd90613964d26f392.png", alt: "eCOGRA", w: 70, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/d5d6ada061396fd17de50.png", alt: "Gambling Help Online", w: 70, h: 30 },
  { src: "https://xt30sf.b-cdn.net/media/f27e25b061396265edc8d.png", alt: "18+ Only", w: 30, h: 30 },
];

export default function Footer() {
  return (
    <footer
      className="relative mt-16 overflow-hidden"
      style={{
        background: "linear-gradient(180deg, rgba(3,7,33,0) 0%, rgba(3,7,33,1) 10%)",
        borderTop: "1px solid rgba(201,168,76,0.08)",
      }}
    >
      {/* Top glow line */}
      <div className="light-line"></div>

      <div className="max-w-5xl mx-auto px-6 py-14">
        {/* Logo */}
        <div className="flex justify-center mb-4">
          <img
            src={LOGO}
            alt="Rolex9"
            className="h-14 w-auto object-contain"
            style={{ filter: "drop-shadow(0 0 16px rgba(201,168,76,0.25))" }}
          />
        </div>
        <p className="text-white/25 text-xs tracking-[0.3em] uppercase text-center mb-10">Australia&apos;s Premier Online Casino Platform</p>

        {/* Divider */}
        <div className="light-line mb-8"></div>

        {/* Payment logos */}
        <div className="flex flex-wrap justify-center items-center gap-5 mb-6">
          {paymentLogos.map((logo) => (
            <img
              key={logo.alt}
              src={logo.src}
              alt={logo.alt}
              width={logo.w}
              height={logo.h}
              className="opacity-80 hover:opacity-100 transition-opacity"
            />
          ))}
        </div>

        {/* Trust logos */}
        <div className="flex flex-wrap justify-center items-center gap-5 mb-10">
          {trustLogos.map((logo) => (
            <img
              key={logo.alt}
              src={logo.src}
              alt={logo.alt}
              width={logo.w}
              height={logo.h}
              className="opacity-70 hover:opacity-100 transition-opacity"
            />
          ))}
        </div>

        {/* Legal */}
        <div className="text-center">
          <p className="text-white/20 text-xs leading-relaxed max-w-3xl mx-auto mb-4">
            Rolex9 is an online casino platform operated for Australian players. Licensed by PAGCOR (Philippines Amusement and Gaming Corporation) and Gaming Curacao. Gambling can be addictive — please play responsibly. 18+ only. For support visit Gambling Help Online at gamblinghelponline.org.au or call 1800 858 858.
          </p>
          <p className="text-white/15 text-xs tracking-widest">
            &copy; 2026 ROLEX9 &nbsp;·&nbsp; rolex9.net &nbsp;·&nbsp; All rights reserved
          </p>
        </div>
      </div>

      {/* Bottom ambient glow */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 w-96 h-32 pointer-events-none"
        style={{ background: "radial-gradient(ellipse, rgba(201,168,76,0.06) 0%, transparent 70%)" }}
      ></div>
    </footer>
  );
}
